module.exports = __webpack_public_path__ + "img/en.43fef2bc.png";